export class Search {

  constructor(
    public searchCase: string,
    public tenantId: string,
    public fromDate: string,
    public toDate: string,
    public transactionId: string,
    public tenantAccessKey: string,
    public lastEvaluatedKey: LastEvaluatedKey,
  ) { }
}

export class LastEvaluatedKey {
  constructor(
    public tenantId: string,
    public transactionId: string,
    public transactionEpochTime: number
  ) { }
}
